import { useQuery } from '@tanstack/react-query';

import { AuthAPI } from '../services/auth.service';

export const useLoginWithGoogle = () => {
  return useQuery({
    queryKey: ['login'],
    queryFn: () => AuthAPI.login(),
    enabled: false,
  });
};
